import React from "react";

const SugarFree = ({ fill, light, size }) => {
  return (
    <svg
      width={size || "72"}
      height={size || "72"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      className="m-1"
    >
      <g id="sugar-free_1_">
        <g id="circle_1_">
          <path
            fill={fill}
            d="M25,50C11.2,50,0,38.8,0,25S11.2,0,25,0c13.8,0,25,11.2,25,25S38.8,50,25,50z M25,1.1
			C11.8,1.1,1.1,11.8,1.1,25S11.8,48.9,25,48.9S48.9,38.2,48.9,25S38.2,1.1,25,1.1z"
          />
        </g>
        <path
          id="text_1_"
          fill={light ? "#595A5A" : "#fff"}
          d="M15.4,25c-0.4-0.4-0.9-0.8-1.6-0.8c-1,0-1.6,0.7-1.6,1.6c0,1.1,0.9,1.6,1.8,2.2
		c0.9,0.6,1.8,1.2,1.8,2.5c0,1.4-1,2.7-2.7,2.7c-0.6,0-1.2-0.2-1.7-0.5v-1.2c0.5,0.4,1.1,0.8,1.7,0.8c1.1,0,1.6-0.8,1.6-1.7
		c0-1.1-0.9-1.6-1.8-2.2c-0.9-0.6-1.8-1.2-1.8-2.6c0-1.3,0.9-2.5,2.5-2.5c0.6,0,1.2,0.2,1.7,0.5V25z M21.7,30.1
		c0,1.8-0.2,3.2-2.3,3.2c-2.2,0-2.3-1.5-2.3-3.2v-6.6h1V30c0,1.6,0.1,2.4,1.3,2.4c1.1,0,1.3-0.8,1.3-2.4v-6.5h1V30.1z M25.4,28h2.5
		v1.8c0,1.5-0.1,3.4-2.3,3.4c-2.3,0-2.5-2.1-2.5-5.2c0-2.3,0.3-4.7,2.6-4.7c1.3,0,1.9,0.8,2.2,1.8l-1,0.3c-0.1-0.6-0.4-1.3-1.2-1.3
		c-1.5,0-1.6,2.1-1.6,3.8c0,3.5,0.5,4.4,1.5,4.4c1.1,0,1.2-0.7,1.2-2.8v-0.7h-1.5V28z M33.6,33.1h-1.1l-0.4-2h-2.3l-0.4,2h-1.1
		l2.1-9.6h0.9L33.6,33.1z M32,30.4l-0.7-3.7c-0.1-0.6-0.2-1.3-0.3-2h-0.1c-0.1,0.6-0.2,1.3-0.3,2L30,30.4H32z M34.5,33.1v-9.6h1.1
		c1.5,0,2.9,0.1,2.9,2.4c0,1.2-0.3,2.4-2,2.5l2.4,4.7h-1.1l-2.3-4.7h0v4.7H34.5z M35.5,27.7h0.4c1.4,0,1.6-0.4,1.6-1.7
		c0-1.5-0.5-1.7-1.8-1.7h-0.2V27.7z M19.2,35.9h-2.4v3.4h2.3v0.8h-2.3v4.6h-1v-9.6h3.4V35.9z M20.7,44.7v-9.6h1.1
		c1.5,0,2.9,0.1,2.9,2.4c0,1.2-0.3,2.4-2,2.5l2.4,4.7H24L21.7,40h0v4.7H20.7z M21.7,39.3H22c1.4,0,1.6-0.4,1.6-1.7
		c0-1.5-0.5-1.7-1.8-1.7h-0.2V39.3z M29.5,35.9h-2.4v3.4h2.3v0.8h-2.3v3.8h2.4v0.8h-3.4v-9.6h3.4V35.9z M34.4,35.9H32v3.4h2.3v0.8
		H32v3.8h2.4v0.8H31v-9.6h3.4V35.9z"
        />
        <path
          id="sugar_1_"
          fill={fill}
          d="M24.3,22.1c2.2-1.6,3.8-2.9,4.7-4.1c0.4-0.5-1.6-1.1-3-1.7l2.6,0.2l6.3,4.4l0,0
		c0.1-0.5-0.9-1.2-1.3-1.6c-0.7-0.6-1.5-1.2-2.3-1.7c0.8,0.2,1.6,0.4,1.6,0.1c0-0.4,0.1-0.8,0-1.3l1.6,0.6c0,0-0.6-0.7-0.6-0.7
		c-0.3-0.2-0.6-0.4-1.1-0.6c-0.1-0.6-0.2-1.3-0.3-2.1c0-0.1-0.1,0.4-0.1,0.5c0,0.4,0.1,0.9,0.1,1.4c-1.4-0.6-3.3-1.1-3.8-1.2
		c0-0.1,0-0.1-0.1-0.1c-0.7-0.2-1.7-0.4-3.1-0.5C25.6,13.9,26,14,26,14c0.6,0.1,1.6,0.3,2.2,0.4l-1.7-0.1c-0.2-0.3-1.6-0.7-2.2-1.1
		c0,0-0.2,0.1-0.2,0.1l2.1,0.9c0,0,0,0,0,0.1l-2.1-0.1c0-0.2-0.6-0.5-1-1l1.6-0.1c0.1,0,0.1,0,0.2,0l-0.3,0.2c0,0,0.2,0.1,0.3,0
		c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c1.5-0.1,4.2-0.4,4.7-0.9c1.3-1.1,3-2.7,4.3-3.5l1.3,0.6
		c0.1,0,0.1,0.1,0,0.2c-0.3,0.3-1.4,1.4-2,1.8c0,0-0.3,0.4-0.2,0.3c1.1-0.8,2-1.5,2.5-2.1c0.2-0.2-0.8-0.5-1.5-0.8
		c0,0,0.1,0,0.1-0.1c0.4-0.2,1.2-1.6,1.2-1.9l0,0l-3.4,2.8c0.5-0.6,0.9-1.2,0.6-1.3c-1.1-0.4-2.9-0.8-5.1-1.1
		c-0.1,0,0.5,0.2,0.6,0.2c1.2,0.2,3.4,0.8,4.2,1c0.1,0,0.2,0.1,0.1,0.2L32.2,10l-0.9,0.7c0.2-0.5,0.7-1,0.4-1c-0.7-0.1-1.7,0-3,0.1
		c-0.1,0,0.3,0.1,0.4,0.1c0.7,0,2.1,0,2.5,0c0.1,0,0,0,0,0.1l-0.4,0.8L29.8,12c-0.2,0.1-0.4,0.2-0.7,0.2l-0.4,0
		c0.8-0.3,1.5-0.6,1.3-0.9c-0.7-0.9-2-2-3.7-3.3c-0.1-0.1,0.3,0.4,0.3,0.5c0.9,0.7,2.5,2.3,3,2.9c0.1,0.1,0.1,0.2,0,0.3l-1.4,0.6
		l-0.5,0c0.4-0.9,1.2-1.7,0.7-1.7c-0.4-0.1-0.9-0.1-1.4-0.1c0.3-0.5,0.4-0.9,0-0.9c-2-0.3-4.8-0.1-8.3,0.3c-0.2,0,0.9,0.2,1,0.2
		c0.5,0,1.1-0.1,1.8-0.1c0.1,0.1,0.5,0.3,0.6,0.3c0.4,0.1,1,0.3,1.5,0.4c-0.2,0-0.5,0-0.7,0.1c-0.1,0,0.6,0.1,0.7,0.1
		c0.2,0,0.3,0,0.5,0c0.8,0.3,1.6,0.5,2.1,0.7l-0.4,0.9l-2.1,0.1c0.5-0.6,0.9-1,0.5-1.1c-0.5-0.1-1.2-0.2-2-0.3
		c0-0.1-0.1-0.1-0.2-0.2c-0.8-0.1-1.8-0.1-3.1,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c-0.7,0-1.5,0.1-2.3,0.2c-0.1,0,0.6,0.1,0.7,0.1
		c0.8-0.1,2.2-0.1,3.3,0c0.5,0.1,1,0.1,1.4,0.2c0,0,0,0,0,0l-0.2,0.4c-1-0.3-2.5-0.4-4.5-0.4c-0.1,0,0.4,0.2,0.5,0.2
		c1,0.1,3.1,0.4,3.7,0.5c0.1,0,0,0.1,0,0.2l-0.3,0.5L10.1,13l0.1,1.6l0.1,0l-0.1,0.7l7.5,0.5l0.8,1.2c0,0.1,0.1,0.2,0,0.2
		c-0.8,0.1-3.4,0.4-4.6,0.5c-0.1,0-0.8,0.2-0.7,0.2c2.4,0,4.3-0.1,5.6-0.4c0.5-0.1-0.4-0.8-0.9-1.6l2.7,0.2l0.9,1.5
		c0,0.1,0.1,0.2,0,0.2c-1,0.1-4.1,0.5-5.7,0.6c-0.1,0-0.9,0.2-0.8,0.2c2.9,0,5.3-0.2,6.8-0.5c0.6-0.1-0.4-1-1.1-2l2.8,0.2l0.5,0.5
		c0,0,0,0,0,0c-0.1,0-0.3,0.4-0.3,0.4c0.1-0.1,0.3-0.2,0.4-0.3l0.7,0.6c0.1,0.1,0,0.3-0.2,0.3c-1,0.3-4,1.3-5.5,1.6
		c-0.1,0-0.9,0.4-0.8,0.4c2.9-0.5,5.2-1.1,6.6-1.8c0.4-0.2-0.2-0.6-0.9-1.2c0.2-0.1,0.4-0.3,0.5-0.4l0.7,0l3.1,1.4
		c0.1,0.1,0.1,0.2,0,0.3c-0.7,0.6-2.7,2.6-3.8,3.5C24.7,21.6,24.2,22.2,24.3,22.1z M28.8,14.9l3.9,1.5c0,0.5,0,1,0,1.2
		c0,0.1-0.1,0.2-0.2,0.2L31,17.4c-0.9-0.6-1.8-1.2-2.2-1.4c-0.2-0.1-0.4-0.2-0.6-0.2l-0.1,0c0.2-0.3,0.5-0.6,0.6-0.9L28.8,14.9z
		 M21.6,13.5l0.4,0.6c0,0,0,0.1,0,0.1l-1.9-0.1c0.1,0,0.1,0,0.2,0c0.2,0,0-0.2-0.2-0.5L21.6,13.5z M20.1,13.9c0,0.1,0.1,0.1,0,0.1
		c-0.2,0-0.7,0.1-1.1,0.1l-3.2-0.1l4.2-0.4L20.1,13.9z M18.4,14.7c-0.1,0-0.4,0.1-0.4,0.1l-1.5-0.1L18.4,14.7z M20.5,14.7l2,0
		c-0.4,0.1-0.8,0.3-1.2,0.4l-3.2-0.3C19,14.8,19.8,14.8,20.5,14.7z M21.8,15.2c0.6-0.1,1-0.3,1.5-0.4l2.7,0
		c-0.2,0.2-0.5,0.4-0.7,0.7L21.8,15.2z M24,14.1c0,0.1,0,0.2-0.1,0.2c0,0,0,0,0,0l-1.6-0.1c-0.1-0.2-0.3-0.4-0.6-0.8l1.2-0.1
		l-0.1,0.2c0,0,0.2,0.1,0.3,0c0-0.1,0-0.1,0.1-0.2l0.1,0L24,14.1z M28.2,10.8c0.1,0,0.1,0.1,0,0.2l-0.6,1.3l-1.4,0.1
		c0.5-0.4,1-0.8,0.6-0.9c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.2-0.3,0.3-0.5C27.4,10.8,27.9,10.8,28.2,10.8z M21.6,9.9
		c1.9,0,4.2,0,5.1,0c0.2,0,0.1,0.1,0.1,0.3l-0.1,0.2c-0.7,0-1.4,0-2.2,0.1C23.6,10.4,22.6,10.2,21.6,9.9z M25.2,10.8
		c0.5,0,0.9,0,1.4,0l-0.2,0.4C26,11.1,25.6,10.9,25.2,10.8z M26.4,11.6c0,0,0.1,0,0.1,0c0.1,0,0.2,0.2,0.1,0.3l-0.5,0.5l-0.1,0
		C26.1,12.1,26.3,11.8,26.4,11.6z M23.9,11.6c0.1,0,0,0.1,0,0.2l-0.5,0.7l-2,0.1c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.1,0.1-0.2,0.2-0.3
		c0.1-0.2,0.3-0.4,0.3-0.6C22.9,11.4,23.6,11.5,23.9,11.6z M24.1,16.6c-0.1-0.1-0.3-0.3-0.4-0.4l0.8,0.1
		C24.3,16.4,24.2,16.5,24.1,16.6z M26.3,14.8l2.2,0L28,15.8l-2.4-0.2C25.9,15.3,26.1,15,26.3,14.8z"
        />
      </g>
    </svg>
  );
};

export default SugarFree;
